import { ColorEnum } from '@/constants/color'
import { measureItemLeftPositionRelativeToAncestor } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/parts/BarItem/utils'
import { MeasureItemLeftPosition } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import Description from '@/features/ui/typography/components/Description'
import { FC, memo, useRef } from 'react'
import { Pressable, View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

type Type = 'category' | 'subcategory'

interface BarItemProps {
    children: string
    type?: Type
    id: string
    selected: boolean
    onPress: (id: string, measureItemLeftPosition: MeasureItemLeftPosition) => void
}

const BarItem: FC<BarItemProps> = ({ children, type = 'category', id, selected, onPress }) => {
    const ref = useRef<View>(null)

    const { styles } = useStyles(stylesheet, { type })

    const handlePress = () => {
        onPress(id, (containerRef) => measureItemLeftPositionRelativeToAncestor(containerRef, ref))
    }

    return (
        <Pressable
            onPress={handlePress}
            style={[styles.container, styles.extraContainer(type, selected)]}
            ref={ref}
        >
            <Description font="bold" numberOfLines={1} style={styles.extraText(type, selected)}>
                {children}
            </Description>
        </Pressable>
    )
}

const stylesheet = createStyleSheet({
    container: {
        justifyContent: 'center',
        borderRadius: 8,
        userSelect: 'none',
        height: 48,
        maxWidth: '100%',
        paddingHorizontal: 12,
        variants: {
            type: {
                category: {
                    backgroundColor: ColorEnum.VIOLET_100,
                },
                subcategory: {
                    backgroundColor: ColorEnum.YELLOW_200,
                },
            },
        },
    },
    extraContainer: (type: Type, selected: boolean) => {
        if (!selected) return {}

        return { backgroundColor: type === 'category' ? ColorEnum.BRICK_600 : ColorEnum.YELLOW_400 }
    },
    extraText: (type: Type, selected: boolean) => {
        if (!selected || type !== 'category') return {}

        return { color: ColorEnum.WHITE }
    },
})

export default memo(BarItem)
